export const makeChannelDisplayName = (channel: any) => {
  return (
    channel?.alias || channel?.partner_public_key.slice(0, 10) || "Unknown"
  );
};

export const shouldShowOutboundReserveWarning = (channel: any) => {
  if (channel.local_balance == 0) {
    return false;
  }
  if (channel.local_balance < channel.local_reserve) {
    return true;
  }
  return false;
};

export const shouldShowInboundReserveWarning = (channel: any) => {
  if (channel.remote_balance == 0) {
    return false;
  }
  if (channel.remote_balance < channel.remote_reserve) {
    return true;
  }
  return false;
};
